const ANIMATION_DURATION = 400;
const ANIMATION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
const SCALE_TARGET = 0.1;

async function animateCardToTarget(
  sourceElement: HTMLElement,
  destinationElement: HTMLElement
): Promise<void> {
  const sourceRect = sourceElement.getBoundingClientRect();
  const destRect = destinationElement.getBoundingClientRect();

  const clone = sourceElement.cloneNode(true) as HTMLElement;
  Object.assign(clone.style, {
    position: 'fixed',
    top: `${sourceRect.top}px`,
    left: `${sourceRect.left}px`,
    width: `${sourceRect.width}px`,
    height: `${sourceRect.height}px`,
    margin: '0',
    pointerEvents: 'none',
    zIndex: '9999',
    transformOrigin: 'center',
  });
  document.body.appendChild(clone);

  const translateX =
    destRect.left +
    destRect.width / 2 -
    (sourceRect.left + sourceRect.width / 2);
  const translateY =
    destRect.top +
    destRect.height / 2 -
    (sourceRect.top + sourceRect.height / 2);

  const animation = clone.animate(
    [
      {transform: 'translate(0, 0) scale(1)', opacity: 1},
      {
        transform: `translate(${translateX}px, ${translateY}px) scale(${SCALE_TARGET})`,
        opacity: 0,
      },
    ],
    {
      duration: ANIMATION_DURATION,
      easing: ANIMATION_EASING,
      fill: 'forwards',
    }
  );

  await animation.finished;
  clone.remove();
}

export default animateCardToTarget;
